<template>
  <div class="md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <!-- {{ $route.params }} -->
    <BackButton @back="back('submit-request')" />
    <v-card class="mb-2">
      <v-card-text>
        <v-card-title primary-title> Waive penalties </v-card-title>
        <div>
          <v-textarea
            outlined
            color="#eee"
            placeholder="Limit to 100 characters only"
            label="Specify what penalties to waive"
            v-model="penalties_to_waive"
          ></v-textarea>
        </div>
        <div>
          <v-textarea
            outlined
            color="#eee"
            placeholder="Limit to 300 characters only"
            label="Justification"
            v-model="justification"
          ></v-textarea>
        </div>
        <div class="px-2">
          Any separate requests indicated in the ‘Justification’ will not be
          acknowledged for processing.
        </div>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title>
        Add a brief description of the attached file
      </v-card-title>
      <v-card-subtitle>
        All attached files shall be for the purpose of showing supporting data
        only for your appeal. Any separate requests indicated in the attached
        files will not be acknowledged for processing.
      </v-card-subtitle>
      <v-card-text>
        <div class="md:flex items-center">
          <div class="mr-2 border-gray-500 border w-full">
            <input
              class="bg-white w-full px-4 py-2"
              type="text"
              name="Description"
              v-model="description"
            />
          </div>
          <!-- <div class="mr-2 border-gray-500 border">
            <input
              class="bg-white w-full px-4 py-2"
              type="text"
              name="Description"
            />
          </div> -->
          <v-btn small elevation="" color="">Add attachment</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title primary-title> Reminders and guidelines </v-card-title>
      <v-card-text>
        <div>
          <HTML />
        </div>
      </v-card-text>
    </v-card>
    <AlertDialog
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <v-btn @click="submit" class="w-full my-4 py-6" small color="blue"
      >SUBMIT REQUEST</v-btn
    >
  </div>
</template>
<script>
import HTML from "../../screens/waivePenaltiesScreen/components/html.vue";
import AlertDialog from "../../common/AlertDialog.vue";
import axios from "axios";
import BackButton from '../../common/BackButton.vue';

export default {
  data() {
    return {
      penalties_to_waive: "",
      showAlert: false,
      justification: "",
      description: "",
    };
  },
  components: {
    HTML,
    AlertDialog,
    BackButton
  },
  methods: {
    back(name) {
      this.$router.push({
        name: name,
      });
    },
    submit() {
      this.showAlert = true;
    },
    toServer() {
      let data = {
        user_id: localStorage.getItem("userId"),
        request_type_id: this.$route.params.request_type_id,
        department_id: 1,
        classification_id: this.$route.meta.classification_id,
        status_id: 1,
        remarks_id: 1,
        justification: this.justification,
        documents: "123",
        subject: this.$route.params.subject,
        email: localStorage.getItem("email"),
      };
      // Validation to ensure data is not null or empty
      for (let key in data) {
        if (!data[key]) {
          alert("System is currently unavailable. Please try again.");
          return;
        }
      }

      axios.post("/tickets/add", data).then((res) => {
        if (res.data.status) {
          alert(res.data.message);
        }
      });
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      if (!this.$route.path.includes(name)) {
        this.$router.push(name);
        this.toServer();
      }
    },
  },
};
</script>